import { TextField, ValidationErrors } from "@compass/core";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker as MuiDateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { displayErrorMessages, getErrorMessages } from "../common/input-functions";

type DateTimePickerProps = {
  label?: string;
  value?: any;
  onChange: (date: any | undefined, keyboardInputValue?: string) => void;
  errors?: ValidationErrors | string[];
  required?: boolean;
};

export const DateTimePicker = ({ label, value, onChange, errors, required, ...rest }: DateTimePickerProps) => {
  const errorMsg = getErrorMessages(errors);
  const hasError = errorMsg?.length > 0 ? true : false;

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <MuiDateTimePicker
        //clearable={true}
        label={label}
        value={value}
        onChange={onChange}
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            required={required}
            variant={"outlined"}
            error={params.error ? params.error : hasError}
            helperText={displayErrorMessages(errorMsg)}
          />
        )}
      />
    </LocalizationProvider>
  );
};
